import { ProductCollectionsList } from "../ProductCollections";
import ProductsList from "./ProductsList";

const ProductCollection = () => {
	return (
		<div className="flex container w-full">
			<div className="flex-none">
				<ProductCollectionsList />
			</div>
			<div className="flex-1 pl-20">
				<ProductsList />
			</div>
		</div>
	);
};

export default ProductCollection;
